module.exports = require("@angular-devkit/schematics");